import { useEffect, useRef, useState } from "react";

export function useEndpoint(fetcher, deps) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const ticket = useRef(0);

  useEffect(() => {
    const mine = ++ticket.current;
    setLoading(true);

    fetcher().then(
      (result) => {
        if (mine !== ticket.current) return;
        setData(result);
        setError(null);
        setLoading(false);
      },
      (err) => {
        if (mine !== ticket.current) return;
        setError(err.message);
        setLoading(false);
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error };
}
